export default __webpack_public_path__ + "static/media/topomap_relative_eeg.def46a0c.webp";